import React, { PropTypes } from 'react';
import Modal from 'react-bootstrap/lib/Modal';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './ModalInfo.scss';
import Button from 'react-bootstrap/lib/Button';
import { layoutColorStyle } from '../utils/utils';


const ModalInfo = (props) => {
  return (
    <Modal name={props.name} show={props.show} onHide={props.onHide}>
      <Modal.Header closeButton style={{ color: layoutColorStyle[props.colors].color, backgroundColor: layoutColorStyle[props.colors].backgroundColor }}>
        <Modal.Title >
        {typeof props.title === 'string' ? (
          <div dangerouslySetInnerHTML={{ __html: props.title }} />
        ) : (
          props.title
        )}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ maxHeight: 'calc(100vh - 300px)', overflowY: 'auto', color: layoutColorStyle[props.colors].color, backgroundColor: layoutColorStyle[props.colors].backgroundColor }}>
        {typeof props.bodyText === 'string' ? (
          <div dangerouslySetInnerHTML={{ __html: props.bodyText }} />
        ) : (
          props.bodyText
        )}
      </Modal.Body>
      <Modal.Footer style={{ color: layoutColorStyle[props.colors].color, backgroundColor: layoutColorStyle[props.colors].backgroundColor }}>
        <Button className="btn btn-primary center-block" onClick={props.onSave} >Zapoznałem się</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default withStyles(s)(ModalInfo);



// WEBPACK FOOTER //
// src/components/ModalInfo/ModalInfo.js